import { AppContext } from "AppContainer";
import Button from "components/Button";
import { useModals } from "components/Modal";
import Status from "components/Status";
import moment from "moment";
import { useContext } from "react";
import EditDeliveryView from "./EditDeliveryView";

const InventoryProductTableView = ({ product, rows }) => {
  const { user } = useContext(AppContext);

  const modal = useModals();

  function updateDelivery(delivery) {
    modal.present({
      title: "Edit Delivery / 修改交货信息",
      subtitle: `[${product.number}] ${product.name}`,
      center: true,
      maxWidth: "max-w-3xl",
      children: (
        <EditDeliveryView
          supplierId={user.supplier.id}
          productId={product.id}
          delivery={delivery}
          hide={modal.dismiss}
        />
      ),
    });
  }

  return (
    <table className="bg-white dark:bg-gray-800 font-code">
      <thead>
        <tr className="sticky top-0 bg-gray-50 dark:bg-gray-900 z-10">
          <th className="px-6 py-3">Date / 日期</th>
          <th className="px-6">Reference</th>
          <th className="px-6"></th>
          <th className="px-6 text-right">QTY / 数量</th>
          <th className="px-6 text-right">Forecast / 预计剩余数量</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((row, index) => (
          <tr
            key={index}
            className={`border-y border-gray-100 dark:border-gray-700
              ${row.type === "SS" ? "bg-blue-100 font-semibold sticky top-[43px] z-10" : ""}
          `}
          >
            <td className="px-6">{moment(row.date).format("YYYY-MM-DD")}</td>
            <td className="px-6 w-full">
              <div className="flex items-center space-x-2">
                <div className="flex flex-col items-start">
                  <div>
                    {row.type === "SS" ? (
                      <div className="flex justify-end">
                        <Button onClick={() => updateDelivery(row)}>
                          {row.origin}
                        </Button>
                      </div>
                    ) : (
                      <div className="flex items-center space-x-2">
                        <div>
                          [{row.type === "PLAN" ? "Plan / 计划" : row.type}]{" "}
                          {row.origin}
                        </div>
                        <Status status={row.state.toUpperCase()} />
                      </div>
                    )}
                  </div>
                  {row.remark && (
                    <div className=" font-normal text-xs">{row.remark}</div>
                  )}
                </div>
              </div>
            </td>
            <td className="px-6 w-full">
              {row.po?.name}
              {row.po ? `(${row.po.qty})` : null}
            </td>
            <td className="px-6 text-right">{row.qty}</td>
            <td className="px-6 text-right">{row.cumsum}</td>
          </tr>
        ))}
      </tbody>
      <tfoot>
        <tr className="sticky bottom-0 z-20 bg-gray-50 dark:bg-gray-900">
          <td colSpan="4"></td>
          <td className="px-6 text-right font-bold text-xl">
            {rows[rows.length - 1].cumsum || 0}
          </td>
        </tr>
      </tfoot>
    </table>
  );
};

export default InventoryProductTableView;
